export default "__VITE_ASSET__1LIcvJrS__"